import { FormControl } from '@angular/forms'

export type ToggleState = boolean | null

export interface ClientIPModalSettings {
	showClosedIP: ToggleState
	showArchivedPrograms: ToggleState
	showTerminatedProgramsEnrollments: ToggleState
	showCompletedGoals: ToggleState
	showCompletedSteps: ToggleState
	dueDate: Date
}

export interface ClientIPOutsideSettings {
  search: string
}

export interface ClientIPSettings extends ClientIPModalSettings, ClientIPOutsideSettings {}

export interface ClientIPModalSettingsForm {
	showClosedIP: FormControl<ToggleState>
	showArchivedPrograms: FormControl<ToggleState>
	showTerminatedProgramsEnrollments: FormControl<ToggleState>
	showCompletedGoals: FormControl<ToggleState>
	showCompletedSteps: FormControl<ToggleState>
	dueDate: FormControl<Date>
}

export enum ClientIPSettingResultType {
	'SUCCESS',
	'SETTING_FAILED',
}

export enum ClientIPSetting {
	SEARCH = 'search',
	SHOW_CLOSED_IP = 'showClosedIP',
	SHOW_ARCHIVED_PROGRAMS = 'showArchivedPrograms',
	SHOW_TERMINATED_PROGRAMS_ENROLLMENTS = 'showTerminatedProgramsEnrollments',
	SHOW_COMPLETED_GOALS = 'showCompletedGoals',
	SHOW_COMPLETED_STEPS = 'showCompletedSteps',
	DUE_DATE = 'dueDate',
}

export type ClientIPSettingResult =
	| { type: ClientIPSettingResultType.SUCCESS }
	| { type: ClientIPSettingResultType.SETTING_FAILED; setting: ClientIPSetting }
